var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSearch = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Search")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4.Structured-Products---Workflow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.-Structured-Products---Parametrization---10",
    transform: "translate(-532.000000, -485.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-57",
    transform: "translate(485.000000, 290.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-53"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-56",
    transform: "translate(30.000000, 161.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-60",
    transform: "translate(15.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Action-/-search"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 17 0 17 17 0 17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9791667,9.91666667 L10.4195833,9.91666667 L10.22125,9.72541667 C10.9154167,8.91791667 11.3333333,7.86958333 11.3333333,6.72916667 C11.3333333,4.18625 9.27208333,2.125 6.72916667,2.125 C4.18625,2.125 2.125,4.18625 2.125,6.72916667 C2.125,9.27208333 4.18625,11.3333333 6.72916667,11.3333333 C7.86958333,11.3333333 8.91791667,10.9154167 9.72541667,10.22125 L9.91666667,10.4195833 L9.91666667,10.9791667 L13.4583333,14.51375 L14.51375,13.4583333 L10.9791667,9.91666667 Z M6.72916667,9.91666667 C4.96541667,9.91666667 3.54166667,8.49291667 3.54166667,6.72916667 C3.54166667,4.96541667 4.96541667,3.54166667 6.72916667,3.54166667 C8.49291667,3.54166667 9.91666667,4.96541667 9.91666667,6.72916667 C9.91666667,8.49291667 8.49291667,9.91666667 6.72916667,9.91666667 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/search.4ff4a751.svg";
export { ForwardRef as ReactComponent };